//-------------------------------------------------------------------------
// Project Summary Controllers
// http://stackoverflow.com/questions/18461263/can-an-angularjs-controller-inherit-from-another-contoller-in-the-same-module
//-------------------------------------------------------------------------
// This module does not seem to  perform any  function; all the useful
// elements  seem to get added to the EICDataStream3.search module
// Maybe this is a refactor-remenant
var EICDataStream3Summary = angular.module("EICDataStream3.summary", ["EICDataStream3.resources"])
  .config(function () {
  });

// Add a reference to  the search module  so that these controllers can be added to  it
var EICDataStream3Search = angular.module("EICDataStream3.search");

EICDataStream3Search.controller('BaseSummaryController', [
  'ENUMS', '$scope', '$rootScope', '$stateParams', '$state', '$timeout', 'dialogs', 'searchService', 'projectDataService', 'trackingStatusService', 'dialogService', 'MEMBERSHIP_CONFIG', 'FEATURE_SWITCHES',
  function (ENUMS, $scope, $rootScope, $stateParams, $state, $timeout, dialogs, searchService, projectDataService, trackingStatusService, dialogService, MEMBERSHIP_CONFIG, FEATURE_SWITCHES) {
    $scope.componentName = "BaseSummaryController";
    $scope.FEATURE_SWITCHES = FEATURE_SWITCHES;
    $scope.NEW_REPORT_REQUEST = FEATURE_SWITCHES.NEW_REPORT_REQUEST;
    $scope.WATCHES = FEATURE_SWITCHES.WATCHES;

    $scope.primaryUpgradeUrl = MEMBERSHIP_CONFIG.primaryUpgradeUrl;

    $scope.searchService = searchService;
    $scope.projectDataService = projectDataService;
    $scope.trackingStatusService = trackingStatusService;

    $scope.$on("NEW_SEARCH", function (event, data) {
      projectDataService.items = [];
      projectDataService.projectNames = [];

      $state.go("search");
    });

    $scope.$emit("DETAIL_PAGE_ACTIVATED", false);


    $scope.getProject = function (projectID) {
      projectDataService.getProject(projectID);
    };


    var offsetDays = 0; //159;
    $scope.highlightDays = -30 - offsetDays;
    $scope.maxDays = -1 - offsetDays;
    $scope.minDays = -90 - offsetDays;

    $scope.pluralDays = "";

    $scope.$watch("highlightDays", function () {
      if ($scope.highlightDays === -1) $scope.pluralDays = "";
      else $scope.pluralDays = "s";
    });


    ////////////////////////////////////////////////////////////////////////
    //////    Selecting projects
    ////////////////////////////////////////////////////////////////////////

    $scope.areAnyProjectsChecked = function () {
      return ($scope.projectSelectionSummary.numberOfProjectsSelected > 0);
    }

    // this structure is passes into the Projects display directive.
    // // it allows values to be passed out again, as well as pre and post
    // // selection special actions
    $scope.projectSelectionSummary = {
      projectSelecting: function (projectID, isChecked) { },
      projectSelected: function (projectID, isChecked) { },

      numberOfProjectsSelected: 0,
      areAnyProjectsSelected: false,
      areAllProjectsSelected: false
    };


    //////////////////////////////////////////////////////////////////////
    ////  Open dialog for selected project(s) watch
    //////////////////////////////////////////////////////////////////////
    $scope.openSelectedProjectWatchDialog = function () {
      dialogService.openSelectedProjectWatchDialog(ENUMS.PROJECT_WATCH_CREATE_REASONS.SELECTED_PROJECTS_FROM_SEARCH);
    };
    //////////////////////////////////////////////////////////////////////


    //////////////////////////////////////////////////////////////////////
    ////  Open dialog for criteria project(s) watch
    //////////////////////////////////////////////////////////////////////
    $scope.openCriteriaProjectWatchDialog = function () {
      dialogService.openSelectedProjectWatchDialog(ENUMS.PROJECT_WATCH_CREATE_REASONS.DYNAMIC_FROM_SEARCH);
    };
    //////////////////////////////////////////////////////////////////////

  }
]);


EICDataStream3Search.controller('ProjectSummaryController', [
  '$scope', '$controller', '$stateParams', '$state', '$location', '$timeout', 'dialogs', 'searchService', 'projectSearchSummaryDataService',
  'projectSummarySortService', 'projectDataService', 'reportRequestService', 'whatIfDialogService', 'summaryDownloadService',
  'geographicalProjectPresenterService', 'exportRequestService', 'FEATURE_SWITCHES',
  function ($scope, $controller, $stateParams, $state, $location, $timeout, dialogs, searchService, projectSearchSummaryDataService,
    projectSummarySortService, projectDataService, reportRequestService, whatIfDialogService, summaryDownloadService,
    geographicalProjectPresenterService, exportRequestService, FEATURE_SWITCHES) {
    $controller('BaseSummaryController', { $scope: $scope }); //This works

    $scope.componentName = "ProjectSummaryController";

    $scope.FEATURE_SWITCHES = FEATURE_SWITCHES;
    $scope.NEW_REPORT_REQUEST = FEATURE_SWITCHES.NEW_REPORT_REQUEST;
    $scope.NEW_EXPORTS = FEATURE_SWITCHES.NEW_EXPORTS;
    $scope.BUSINESS_DEVELOPMENT_TOOLS = FEATURE_SWITCHES.BUSINESS_DEVELOPMENT_TOOLS;

    $scope.projectSearchSummaryDataService = projectSearchSummaryDataService;
    $scope.dataFlowControl = projectSearchSummaryDataService.dataFlowControl;
    $scope.trackingStatusCounts = projectSearchSummaryDataService.trackingStatusCounts;
    $scope.projectDataService = projectDataService;


    $scope.$on("NEW_SEARCH", function (event, data) {
      projectSearchSummaryDataService.items = [];
      projectSearchSummaryDataService.projectNames = [];

      $state.go("search");
    });

    $scope.$emit("DETAIL_PAGE_ACTIVATED", false);

    $scope.$on("SORT_CHANGED", function (event, sort) {
      projectSummarySortService.sort(sort);
    });

    // todo: remove this
    $scope.currentPath = function () {
      // ie objects to the # character and ignores everything that  follows it.
      // Encoding the # in hex (%23) allows outlook to  process the url properly
      // when called from ie
      return $location.absUrl().replace("#", "%23");
    }


    $scope.$watch("searchService.queryDef.guid", function () {
      $scope.summaryGuid = searchService.queryDef.guid;
      $scope.source = "searchresult";
    });

    $scope.$on('$viewContentLoaded', function () {
      projectSearchSummaryDataService.isProject = false;
      projectSearchSummaryDataService.search($stateParams.guid);
    });


    /**************************************************************************
     * Action Menu
     */

    $scope.exportSummary = function () {
      return summaryDownloadService.projectSearch($scope.summaryGuid);
    };



    $scope.share = function () {
      return "mailto:?subject=Search Result from EICDataStream&body=I thought you might be interested in this list of projects from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}", $scope.currentPath());
    };
    $scope.actionMenu = {
      items: [
        // {
        //   text: "Export Summary",
        //   actionType: "function",
        //   action: $scope.exportSummary,
        //   visible: function () { return !$scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED; },
        //   disabled: $scope.areAnyProjectsChecked
        // },
        {
          text: "Export Summary...",
          actionType: "function",
          action: exportRequestService.openProjectExportRequestDialog,
          visible: function () {
            // return true;
            return $scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED && !$scope.NEW_EXPORTS.SUSPENDED;
          },
          disabled: function () { return false }
        },
        {
          text: "Export Service Suspended",
          actionType: "function",
          action: function () { },
          visible: function () {
            return $scope.NEW_EXPORTS.SUSPENDED;
          },
          disabled: function () { return true }
        },
        {
          text: "Share...",
          actionType: "href",
          action: $scope.share,
          visible: function () { return true; },
          disabled: $scope.areAnyProjectsChecked
        },
        {
          text: "PDF Service Suspended",
          actionType: "function",
          action: function () { },
          visible: function () {
            return $scope.NEW_REPORT_REQUEST.SUSPENDED && $scope.NEW_REPORT_REQUEST.SELECTED_PROJECTS_ENABLED;
          },
          disabled: function () { return true }
        },
        {
          text: "PDF of selected projects...",
          actionType: "function",
          action: reportRequestService.openReportRequestDialog_selectedProjects,
          visible: function () {
            return $scope.areAnyProjectsChecked()
              && $scope.NEW_REPORT_REQUEST.SELECTED_PROJECTS_ENABLED
              && !$scope.NEW_REPORT_REQUEST.SUSPENDED;
          },
          disabled: function () { return false }
        },
        {
          text: "PDF of results of this search...",
          actionType: "function",
          action: reportRequestService.openReportRequestDialog_searchResult,
          visible: function () {
            return !$scope.areAnyProjectsChecked()
              && $scope.NEW_REPORT_REQUEST.CRITERIA_PROJECTS_ENABLED
              && !$scope.NEW_REPORT_REQUEST.SUSPENDED;
          },
          disabled: function () { return false }
        },
        {
          text: "Watch selected projects...",
          actionType: "function",
          action: $scope.openSelectedProjectWatchDialog,
          visible: function () {
            return $scope.areAnyProjectsChecked() && $scope.WATCHES.SELECTED_PROJECTS_ENABLED
          },
          disabled: function () { return false }
        },
        {
          text: "Watch results of this search...",
          actionType: "function",
          action: $scope.openCriteriaProjectWatchDialog,
          visible: function () {
            return !$scope.areAnyProjectsChecked() && $scope.WATCHES.CRITERIA_PROJECTS_ENABLED
          },
          disabled: function () { return false }
        },
        {
          text: "Create What-if Analysis...",
          actionType: "function",
          action: whatIfDialogService.open_selectedProjects,
          visible: function () {
            return $scope.areAnyProjectsChecked() && $scope.BUSINESS_DEVELOPMENT_TOOLS.WHAT_IF_PROTOTYPE_ENABLED;
          },
          disabled: function () { return false }
        },
        {
          isDivider: true,
          visible: function () {
            return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
          }
        },
        {
          text: "Show selected projects on a map... (Beta)",
          actionType: "function",
          action: geographicalProjectPresenterService.post_selectedProjects,
          visible: function () {
            return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
          },
          disabled: function () { return !$scope.areAnyProjectsChecked(); }
        }
      ]
    }

  }
]);



EICDataStream3Search.controller('ContractAwardSummaryController', ['$scope', '$rootScope', '$state', '$stateParams', '$location', 'searchService', 'contractDataService', 'summaryDownloadService', 'MEMBERSHIP_CONFIG',
  function ($scope, $rootScope, $state, $stateParams, $location, searchService, contractDataService, summaryDownloadService, MEMBERSHIP_CONFIG) {
    $scope.componentName = "ContractAwardSummaryController";

    $scope.contractDataService = contractDataService;
    $scope.searchService = searchService;

    $scope.primaryUpgradeUrl = MEMBERSHIP_CONFIG.primaryUpgradeUrl;

    $scope.$on("NEW_SEARCH", function (event, data) {
      contractDataService.items = [];
      $state.go('search');
    });

    $scope.currentPath = function () {
      // ie objects to the # character and ignores everything that  follows it.
      // Encoding the # in hex (%23) allows outlook to  process the url properly
      // when called from ie
      return $location.absUrl().replace("#", "%23");
    };

    $scope.$emit("DETAIL_PAGE_ACTIVATED", false);


    $scope.openContract = function (contractID, shortContractType, contractorName, projectName, allowRevertToSummary) {
      // close the criteria panel
      contractDataService.isContract = true;
      contractDataService.allowRevertToSummary = allowRevertToSummary;
      contractDataService.stateParams = $stateParams;
      var contractDescription = formatContractDescription(shortContractType, contractorName.substring(0, 50), projectName.substring(0, 50));
      $state.go('search.contract', { contractID: contractID, contractDescription: contractDescription });
    };


    var formatContractDescription = function (shortContractType, contractorName, projectName) {
      return shortContractType.urlEncode() + "-" + contractorName.urlEncode() + "-" + projectName.urlEncode();
    };


    $scope.$on("SORT_CHANGED", function (event, sort) {
      searchService.queryDef.sorting.sort_order = sort.sortField;
      searchService.queryDef.sorting.sort_desc = sort.sortDesc;
      searchService.queryDef.paging.offset = 0;
      contractDataService.items = [];
      contractDataService.count = 0;

      contractDataService.contractAwardSearch(searchService.queryDef);
    });



    /**************************************************************************
     * Action Menu
     */

    $scope.exportSummary = function () {
      return summaryDownloadService.contractAwardSearch($scope.summaryGuid);
    };

    $scope.share = function () {
      return "mailto:?subject=Search Result from EICDataStream&body=I thought you might be interested in this list of projects from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}", $scope.currentPath());
    };

    $scope.actionMenu = {
      items: [
        {
          text: "Export Summary",
          actionType: "function",
          action: $scope.exportSummary,
          visible: function () { return true; },
          disabled: $scope.areAnyProjectsChecked
        },
        {
          text: "Share...",
          actionType: "href",
          action: $scope.share,
          visible: function () { return true; },
          disabled: $scope.areAnyProjectsChecked
        }
      ]
    }
    /************************************* Action Menu *************************************/





    $scope.$watch("searchService.queryDef.guid", function () {
      $scope.summaryGuid = searchService.queryDef.guid;
      $scope.source = "searchresult";
    });


    $scope.$on('$viewContentLoaded', function () {
      // close down the controller/ release resources etc.
      contractDataService.isContract = false;
      contractDataService.search($stateParams.guid);
    });

  }]);


